import { createContext } from "react";
export const PrivilegesContext = createContext<any>({});
